import { Flex } from '@chakra-ui/react'

import type { SeriesStreakBarData } from '@/common/services/seriesPage/types'

import getCurrentStreak from '@/components/Series/SeriesStreakBar/internal/getCurrentStreak'
import getLongestStreak from '@/components/Series/SeriesStreakBar/internal/getLongestStreak'
import getSeriesStreakItems from '@/components/Series/SeriesStreakBar/internal/getSeriesStreakItems'
import SeriesStreakItems from '@/components/Series/SeriesStreakBar/SeriesStreakItems'
import SeriesStreakStatus from '@/components/Series/SeriesStreakBar/SeriesStreakStatus'

export default function SeriesStreakBar({ series }: { series: SeriesStreakBarData }) {
  const items = getSeriesStreakItems(series.sessions)

  if (items.length < 2) {
    return null
  }

  const longestStreak = getLongestStreak(items)
  const currentStreak = getCurrentStreak(items)

  const hasUpcomingSessions = items[items.length - 1].hasEnded === false

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      alignItems="center"
      justifyContent={{ md: 'flex-start' }}
    >
      <SeriesStreakItems items={items} hasUpcomingSessions={hasUpcomingSessions} />
      <SeriesStreakStatus
        hasUpcomingSessions={hasUpcomingSessions}
        currentStreak={currentStreak}
        longestStreak={longestStreak}
      />
    </Flex>
  )
}
